import type { Todo } from 'owa-todo-types';
import { todoUpdated } from '../actions/publicActions';
import { updateTodo as updateTodoAction } from 'owa-todo-cache';

export async function updateTodoInternal(todoId: string, todoUpdates: Partial<Todo>) {
    const isSuccess = await updateTodoAction(todoId, todoUpdates);
    todoUpdated(isSuccess);
}
